import { render, staticRenderFns } from "./UpdatePasswordContainer.vue?vue&type=template&id=180f095e&"
import script from "./UpdatePasswordContainer.vue?vue&type=script&lang=js&"
export * from "./UpdatePasswordContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports